module.exports = __webpack_public_path__ + "img/title_main.f4bf72d4.png";